import { render, staticRenderFns } from "./StyledOverviewInfo.vue?vue&type=template&id=69601906&scoped=true"
import script from "./StyledOverviewInfo.vue?vue&type=script&lang=js"
export * from "./StyledOverviewInfo.vue?vue&type=script&lang=js"
import style0 from "./StyledOverviewInfo.vue?vue&type=style&index=0&id=69601906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69601906",
  null
  
)

export default component.exports